/**
 * Sessie 53 blok 3, fix K2 (punt 20): wanneer "x van N" in Per vraagtype
 * staat. Los bestand zodat PerVraagtype.tsx alleen componenten exporteert.
 */
import type { VraagtypeGezondheid } from "@/lib/api";

export type Rijdata = VraagtypeGezondheid;

/**
 * "x van N" alleen als er nog een voorstel kan komen: niet op groen en
 * niet als de stand al op het hoogste staat dat de motor mag voorstellen.
 */
export function toontTeller(rij: Rijdata): boolean {
  if (rij.teller === null || rij.n === null || rij.stand === null) return false;
  if (rij.stand === "groen") return false;
  return !rij.max_stand || rij.stand !== rij.max_stand;
}
